import { call, put, takeLatest } from 'redux-saga/effects';
import HeroCommerceApi from 'api-services/HeroCommerceApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { GET_LIST_PLANS } from './actionTypes';
import { getListPlansDone, getListPlansError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* listPlans(constAccessParams) {
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroCommerceApi.listPlans, newAccessParams);
    if (isSuccessResponse(result)) {
        yield put(getListPlansDone(result.data.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(getListPlansError(result));
    }
}
export function* watchListPlansCalls(constAccessParams) {
    yield takeLatest(GET_LIST_PLANS, listPlans, constAccessParams);
}
//# sourceMappingURL=saga.js.map